import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import { loggingMiddleware } from '../../utils/store';
import { getActiveObjectEntity, updateAssociatedObject } from './functions';
import { PreviewModalPropsContext } from './PropsContext';
import { GET_ACTIVE_OBJECT_ENTITY, initialState, reducer, RESET_OBJECT_ENTITY, UPDATE_ASSOCIATED_OBJECT } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviewModalContext = /*#__PURE__*/createContext(initialState);
export const PreviewModalContextProvider = ({
  children
}) => {
  const [previewModal, dispatchCTX] = useReducer(loggingMiddleware('preview modal')(reducer), initialState);
  const {
    apiWrapper
  } = useContext(PreviewModalPropsContext);
  const asyncFuncArg = useMemo(() => ({
    dispatch: dispatchCTX,
    apiWrapper
  }), [apiWrapper]);
  const dispatch = useCallback(action => {
    switch (action.type) {
      case UPDATE_ASSOCIATED_OBJECT:
        updateAssociatedObject(asyncFuncArg, action.payload);
        break;
      case GET_ACTIVE_OBJECT_ENTITY:
        getActiveObjectEntity(asyncFuncArg, action.payload);
        break;
      default:
        {
          dispatchCTX(action);
        }
    }
  }, [asyncFuncArg]);
  const actions = useMemo(() => ({
    getActiveObjectEntity: data => dispatch({
      type: GET_ACTIVE_OBJECT_ENTITY,
      payload: data
    }),
    updateAssociatedObject: data => dispatch({
      type: UPDATE_ASSOCIATED_OBJECT,
      payload: data
    }),
    resetObjectEntity: () => dispatch({
      type: RESET_OBJECT_ENTITY
    })
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const state = useMemo(() => Object.assign({}, previewModal, {
    dispatch,
    previewModalActions: actions
  }), [previewModal, dispatch, actions]);
  return /*#__PURE__*/_jsx(PreviewModalContext.Provider, {
    value: state,
    children: children
  });
};